import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientMedicareID from 'utils/print/getPatientMedicareID';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullAddress from 'utils/print/getPrescriberFullAddress';
import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullAddress from 'utils/print/getSupplierFullAddress';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getSignature from 'utils/print/getSignature';

const CMS10125 = {
  ID: 1,
  Name: 'CMS-10125 External Infusion Pumps',
  Type: 'CMS',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/CMS-10125/1.js',
      fields: [
        {
          name: 'Certification Type/Date INITIAL 1',
          type: 'text',
          x: 82,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 2',
          type: 'text',
          x: 88.5,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 3',
          type: 'text',
          x: 95,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 1',
          type: 'text',
          x: 117.5,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 2',
          type: 'text',
          x: 124,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 3',
          type: 'text',
          x: 131,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 1',
          type: 'text',
          x: 167.5,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 2',
          type: 'text',
          x: 174,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 3',
          type: 'text',
          x: 181,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 14.5,
          y: 42,
          width: 92,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 14.5,
          y: 45.1,
          width: 92,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 16,
          y: 53.2,
          width: 10,
        },
        {
          name: 'Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 28,
          y: 53.2,
          width: 10,

        },
        {
          name: 'Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 40,
          y: 53.2,
          width: 14,
        },
        {
          name: 'Medicare ID',
          type: 'text',
          getValue: getPatientMedicareID,
          x: 71,
          y: 53.2,
          width: 35,
        },
        {
          name: 'Supplier Name, Address',
          type: 'text',
          getValue: (props) => {
            if (props.value) {
              return props.value;
            }
            return `${getSupplierName(props)}, ${getSupplierFullAddress(props)}`;
          },
          x: 109,
          y: 42,
          width: 92,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Supplier Phone 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 112,
          y: 53.2,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 123,
          y: 53.2,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 136,
          y: 53.2,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Supplier NSC or NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 168,
          y: 53.2,
          width: 24,
        },
        {
          name: 'Place Of Service',
          type: 'text',
          getValue: props => getOrderLinePlaceOfService({ ...props, index: 0 }),
          x: 14.5,
          y: 67,
          width: 59,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 121.5,
          y: 61,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 128.5,
          y: 61,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 135,
          y: 61,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 148,
          y: 61,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 166,
          y: 61,
          width: 7,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 182.5,
          y: 61,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 1',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 84,
          y: 77,
          width: 21,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 2',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 1 }),
          x: 84,
          y: 82.1,
          width: 21,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 3',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 2 }),
          x: 84,
          y: 87.2,
          width: 21,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 4',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 3 }),
          x: 84,
          y: 92.3,
          width: 21,
        },
        {
          name: 'Prescriber Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 109,
          y: 80.1,
          width: 92,
        },
        {
          name: 'Prescriber Email',
          type: 'text',
          getValue: getPrescriberFullAddress,
          x: 109,
          y: 83.5,
          width: 92,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Prescriber Phone 1',
          type: 'text',
          getValue: getPrescriberPhone1,
          x: 112,
          y: 93.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 2',
          type: 'text',
          getValue: getPrescriberPhone2,
          x: 123,
          y: 93.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 3',
          type: 'text',
          getValue: getPrescriberPhone3,
          x: 136,
          y: 93.5,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber NSC or NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 169,
          y: 93.5,
          width: 24,
        },
        {
          name: 'Provide the Supply Item/Service Procedure code(s) for the drug(s) that requires the use of the pump a)',
          type: 'text',
          x: 18,
          y: 112.5,
          width: 86,
        },
        {
          name: 'Provide the Supply Item/Service Procedure code(s) for the drug(s) that requires the use of the pump b)',
          type: 'text',
          x: 18,
          y: 119,
          width: 86,
        },
        {
          name: 'Provide the Supply Item/Service Procedure code(s) for the drug(s) that requires the use of the pump c)',
          type: 'text',
          x: 18,
          y: 126,
          width: 86,
        },
        {
          name: 'If a NOC (not otherwise classified) Supply Item/Service Procedure code is listed in question 1, print name of drug a)',
          type: 'text',
          x: 18,
          y: 136,
          width: 86,
        },
        {
          name: 'If a NOC (not otherwise classified) Supply Item/Service Procedure code is listed in question 1, print name of drug b)',
          type: 'text',
          x: 18,
          y: 142.5,
          width: 86,
        },
        {
          name: 'If a NOC (not otherwise classified) Supply Item/Service Procedure code is listed in question 1, print name of drug c)',
          type: 'text',
          x: 18,
          y: 149.5,
          width: 86,
        },
        {
          name: 'Check number for route of administration? 1 – Intravenous 2 – Subcutaneous 3 – Epidural 4 – Other',
          type: 'radio',
          options: [
            {
              x: 38,
              y: 159.5,
              width: 2,
              height: 2,
              value: '1',
            },
            {
              x: 51.5,
              y: 159.5,
              width: 2,
              height: 2,
              value: '2',
            },
            {
              x: 64.5,
              y: 159.5,
              width: 2,
              height: 2,
              value: '3',
            },
            {
              x: 78,
              y: 159.5,
              width: 2,
              height: 2,
              value: '4',
            },
          ],
        },
        {
          name: 'Check number for method of administration? 1 – Continuous 2 – Intermittent',
          type: 'radio',
          options: [
            {
              x: 51.5,
              y: 172,
              width: 2,
              height: 2,
              value: '1',
            },
            {
              x: 64.5,
              y: 172,
              width: 2,
              height: 2,
              value: '2',
            },
          ],
        },
        {
          name: 'Custom 1',
          type: 'text',
          x: 15,
          y: 179,
          width: 91,
          height: 25.5,
          multiline: true,
        },
        {
          name: 'Custom 2',
          type: 'text',
          x: 110,
          y: 179,
          width: 91,
          height: 25.5,
          multiline: true,
        },
        {
          name: 'Custom 3',
          type: 'text',
          x: 15,
          y: 208,
          width: 186,
          height: 25.5,
          multiline: true,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 50,
          y: 252,
          width: 90,
          height: 8,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 155,
          y: 254,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          x: 163,
          y: 254,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          x: 171,
          y: 254,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
      ],
    },
  ],
};

export default CMS10125;



// WEBPACK FOOTER //
// ./src/config/documents/CMS-10125.js